export default "/images/return.svg?7cbe8c7a6d7b8eb6ebd800a4f5089eb7";